import { makeStyles, tokens } from '@fluentui/react-components';
import React from 'react';

interface ICodeProps {
    text: string;
    preserveLineBreaks: boolean;
}

const useStyles = makeStyles({
    codeBlock: {
        backgroundColor: tokens.colorNeutralBackground5,
        borderRadius: '0px',
        width: '100%',
        fontSize: '16px',
        fontWeight: 'bold',
        border: "none",
        display: 'inline-flex',
        justifyContent: 'center',
        marginTop: tokens.spacingVerticalSNudge,
        marginBottom: tokens.spacingVerticalSNudge,
    },
    single: {
        textAlign: 'center'
    },
    multiple: {
        height: '600px',
        width: '650px',
        resize: "none"
    }
});

const Code = (props: ICodeProps) => {
    const styles = useStyles();

    return props.preserveLineBreaks 
        ? <textarea name='code_block' readOnly={true} className={styles.codeBlock + styles.multiple} value={props.text} />
        : <code className={styles.codeBlock + styles.single}>{props.text}</code>
    
};

export { Code };